import { render, staticRenderFns } from "./ResultExcelAction.vue?vue&type=template&id=72715dd2&"
import script from "./ResultExcelAction.vue?vue&type=script&lang=js&"
export * from "./ResultExcelAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports